<template>
  <PdfRedactingPanelWrapper data-locator="redact-by-zone-card">
    <template #title>
      <h3 class="text-grey-900 text--small">
        {{ $t('common.PdfRedactingSidebar.redactedZones', drawnRectangles.length) }}
      </h3>
      <AppButton
        :data-locator="isRedactByZone ? 'stop-button' : 'start-button'"
        size="small"
        type="outlined"
        variant="neutral"
        @click="$emit('update:isRedactByZone', !isRedactByZone)"
      >
        {{ isRedactByZone
          ? $t('common.PdfRedactingSidebar.stop')
          : $t('common.PdfRedactingSidebar.start')
        }}
      </AppButton>
    </template>

    <template #content>
      <!-- Empty State -->
      <div
        v-if="drawnRectangles.length === 0"
        class="d-flex flex-column justify-center align-center pa-5"
      >
        <v-img :src="getRedactByKeywordsIcon" width="32" />
        <div class="text-grey-800 text--small text-center mt-4">
          <i18n-t
            keypath="common.PdfRedactingSidebar.redactByZoneDescription"
            tag="span"
            scope="global"
          >
            <template #start>
              <span class="font-weight-medium">{{ $t('common.PdfRedactingSidebar.start') }}</span>
            </template>
            <template #stop>
              <span class="font-weight-medium">{{ $t('common.PdfRedactingSidebar.stop') }}</span>
            </template>
          </i18n-t>
        </div>
      </div>

      <!-- List of Zones -->
      <template v-else>
        <div
          v-for="rectangle in drawnRectangles"
          :key="rectangle.id"
          data-locator="redacted-zone"
          :data-rectangle-id="rectangle.id"
          :class="{
            'active-drawn-rectangle-item': rectangle.id === activeRectangleId,
          }"
          class="d-flex align-center justify-space-between mb-3 px-3 py-1 cursor-pointer drawn-rectangle-item"
          @click="$emit('set-active-rectangle-id', rectangle.id)"
        >
          <p class="mb-0 text--small">
            {{
              $t(
                rectangle.isCopy
                  ? 'common.PdfRedactingSidebar.redactedZoneNameCopy'
                  : 'common.PdfRedactingSidebar.redactedZoneName',
                { page: rectangle.page, index: rectangle.index },
              )
            }}
          </p>

          <RedactedZoneItemMenu
            :rectangle="rectangle"
            :all-rectangles="drawnRectangles"
            @delete-rectangle="$emit('delete-rectangle', rectangle)"
            @duplicate-on-all-pages="$emit('duplicate-on-all-pages', rectangle)"
            @delete-on-all-pages="$emit('delete-on-all-pages', rectangle)"
            @set-active-rectangle-id="$emit('set-active-rectangle-id', rectangle.id)"
          />
        </div>
      </template>
    </template>
  </PdfRedactingPanelWrapper>
</template>

<script>
import AppButton from '@/design-system/buttons/AppButton.vue'

import PdfRedactingPanelWrapper from './PdfRedactingPanelWrapper.vue'
import RedactedZoneItemMenu from './RedactedZoneItemMenu.vue'

export default {
  name: 'PdfRedactingSidebarContentZone',
  components: {
    PdfRedactingPanelWrapper,
    AppButton,
    RedactedZoneItemMenu,
  },
  props: {
    drawnRectangles: {
      type: Array,
      required: true,
    },
    activeRectangleId: {
      type: [Number, String, null],
      default: null,
    },
    isRedactByZone: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getRedactByKeywordsIcon() {
      return new URL(`@/assets/img/redact-by-keywords.svg`, import.meta.url).href
    },
  },
}
</script>

<style scoped>
.drawn-rectangle-item {
  border-radius: 8px;
}
.active-drawn-rectangle-item {
  background-color: rgb(var(--v-theme-grey-lighten-4));
}
.drawn-rectangle-item:hover:not(.active-drawn-rectangle-item) {
  background-color: rgba(var(--v-theme-grey-900), 0.05);
}
</style>
